import React, { useState, useEffect } from 'react';
import { SUPPORTED_LANGUAGES_MAP } from '../../../util/constants';
import { IconClose } from '../../../components';
import { useIntl } from '../../../util/reactIntl';

import css from './StoreLanguagePrompt.module.css';

const STORAGE_KEY_PREFIX = 'storeLangPromptDismissed_';

export default function StoreLanguagePrompt({ storeId, storeDefaultLanguage }) {
  const intl = useIntl();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !storeId) return;
    const key = `${STORAGE_KEY_PREFIX}${storeId}`;
    try {
      const stored = window.sessionStorage.getItem(key);
      setDismissed(stored === '1');
    } catch (e) {
      setDismissed(false);
    }
  }, [storeId]);

  const handleDismiss = () => {
    setDismissed(true);
    if (typeof window !== 'undefined' && storeId) {
      try {
        window.sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${storeId}`, '1');
      } catch (e) {
        // ignore
      }
    }
  };

  if (!storeId || !storeDefaultLanguage || storeDefaultLanguage === 'en') return null;
  if (dismissed) return null;

  const languageLabel =
    SUPPORTED_LANGUAGES_MAP[storeDefaultLanguage]?.label || storeDefaultLanguage;

  return (
    <div
      className={css.root}
      role="region"
      aria-label={intl.formatMessage({
        id: 'StoreLanguagePrompt.regionAriaLabel',
        defaultMessage: 'Store language notice',
      })}
    >
      <div className={css.content}>
        <span className={css.text}>
          {intl.formatMessage(
            {
              id: 'StoreLanguagePrompt.message',
              defaultMessage:
                'This store is shown in {language}. Prefer another language?',
            },
            { language: languageLabel }
          )}
        </span>
        <span className={css.hint}>
          {intl.formatMessage({
            id: 'StoreLanguagePrompt.hint',
            defaultMessage:
              'Use the language dropdown in the header (desktop) or the side menu (mobile) to switch.',
          })}
        </span>
      </div>
      <button
        type="button"
        className={css.dismissButton}
        onClick={handleDismiss}
        aria-label={intl.formatMessage({
          id: 'StoreLanguagePrompt.dismiss',
          defaultMessage: 'Dismiss',
        })}
      >
        <IconClose />
      </button>
    </div>
  );
}
